"use strict";

import { Swiper, Navigation } from "swiper";

window.addEventListener("load", () => {
    let swiper;
    const Navigation = require("swiper").Navigation;
    const Pagination = require("swiper").Pagination;
    if (!window.einsteinCarouselInitialized) {
        const carousels = $(".product-carousel-swiper");

        carousels.each(function (index, carousel) {
            const selector = "." + $(carousel).data().id + " .swiper";
            const prevButton = "." + $(carousel).data().id + " .swiper-button-prev";
            const nextButton = "." + $(carousel).data().id + " .swiper-button-next";
            const paginationSelector = "." + $(carousel).data().id + " .swiper-pagination";

            // eslint-disable-next-line no-unused-vars
            const einsteinCarousel = new Swiper(selector, {
                loop: false,
                modules: [Navigation, Pagination],
                pagination: {
                    el: paginationSelector,
                    clickable: true,
                },
                autoHeight: true,
                setWrapperSize: true,
                freeMode: true,
                slidesPerView: "auto",
                direction: 'horizontal',
                parallax: true,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                },
                on: {
                    init: function () {
                        $(carousel).closest('.up-4-products-carousel').removeClass('invisible');
                    }
                }
            });
        });
        window.einsteinCarousellInitialized = true;
    }
});
